import { Injectable } from '@angular/core';
import { ComplydomeEvent, ComplydomeEventSubscription } from "./types";
import { Subject } from "rxjs";
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class EventDispatcherService {
  private subject: Subject<ComplydomeEvent<any>> = new Subject<ComplydomeEvent<any>>();
  private subscriptions: ComplydomeEventSubscription<any>[] = [];
  private activeGroupId: string | null = null;

  constructor() {
    this.subject.subscribe((event: ComplydomeEvent<any>) => this.callHandlers(event))
  }

  private callHandlers(event: ComplydomeEvent<any>) {
    this.subscriptions.forEach(subscription => {
      if (subscription.eventType !== event.type) {
        return;
      }

      console.log(`Calling handler for event type: ${event.type}`, event.payload);
      try {
        subscription.handler(event.payload);
      } catch (error) {
        console.error(`Error in handler for event type: ${event.type}`, error);
      }
    });
  }

  dispatchEvent<T>(type: string, payload: T): void {
    console.log(`Event dispatched: ${type}`, payload);
    this.subject.next({
      type,
      payload
    } as ComplydomeEvent<T>);
  }

  subscribeToEvent<T>(type: string, handler: (payload: T) => void): string {
    const subscription = {
      subscriptionId: this.getSubscriptionId(),
      groupId: this.activeGroupId,
      eventType: type,
      handler: handler
    } as ComplydomeEventSubscription<T>;

    this.subscriptions.push(subscription);

    console.log(`Subscribed to event type: ${type} with subscriptionId: ${subscription.subscriptionId}`);

    return subscription.subscriptionId;
  }

  private getSubscriptionId(): string {
    return uuid.v4();
  }

  unsubscribeFromEvent(type: string|null, subscriptionId: string|null): void {
    if (!type && !subscriptionId) {
      return;
    }

    if (subscriptionId) {
      this.subscriptions = this.subscriptions.filter(subscription => {
        return subscription.subscriptionId !== subscriptionId;
      });
    } else {
      this.subscriptions = this.subscriptions.filter(subscription => {
        return subscription.eventType !== type;
      });
    }

    console.log(`Unsubscribed from event type: ${type}, subscriptionId: ${subscriptionId}`);
  }

  subscribeInGroup(subscriptionsSetup: () => void): string {
    const groupId = this.getSubscriptionId();

    this.activeGroupId = groupId;
    subscriptionsSetup()
    this.activeGroupId = null;

    return groupId;
  }

  unsubscribeByGroup(groupId: string): void {
    this.subscriptions = this.subscriptions.filter(subscription => {
      return subscription.groupId !== groupId;
    });

    console.log(`Unsubscribed from group: ${groupId}`);
  }
}
